import React from 'react'
import ClosureSurvey from 'sprockets_react/closure_survey/registry'
import ClosureSurveyData from 'sprockets_react/closure_survey/data/registry'

ClosureSurvey.HowMuchDidYouPay = {
  onSubmit: function(onStepProgression, onRequest, onRequestCompletion) {
    this.validator.validateField('value')
    this.validator.isValidField('value') && onStepProgression()
  },

  buttonLayout: function() {
    return 'none'
  },

  component: React.createClass({
    componentDidMount: function() {
      $('#job-closure-modal').bootstrapValidator({})
      ClosureSurvey.HowMuchDidYouPay.validator = $('#job-closure-modal').data('bootstrapValidator')

      this.setupValidation()
    },

    setupValidation: function() {
      ClosureSurvey.HowMuchDidYouPay.validator.addField('value',
        { validators: {
            notEmpty: {
              message: 'Please type your answer'
            },
            blank: {}
          }
        }
      )
    },

    handleSkipOnClick() {
      ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.SubmitFeedback)
    },

    handleDoneOnClick() {
      ClosureSurveyData.Data.value = $('#value')[0].value
      this.props.onStepProgression()
    },

    render: function() {
      return (
        <div>
          <h3 className="mb15 mt20">What was the final cost of the job?</h3>
          <div className="help-block pb24">
            This helps us get a better understanding of the average cost of jobs in this category and location.
          </div>
          <div className="form-group">
            <div className="input-group">
              <span className="input-group-addon">$</span>
              <input 
                  type="number" 
                  className="form-control"
                  name="value"
                  placeholder="e.g. 200"
                  step=".01"
                  id="value"/>
            </div>
          </div>
          <div className="row pt30">
            <div className='col-sm-6 col-xs-6 pb12 pr4 pull-left'>
              <a href="#" className="btn btn-block btn-clear p12" onClick={this.handleSkipOnClick}>
                Skip
              </a>
            </div>
            <div className='col-sm-6 col-xs-6 pb12 pl4 pull-right'>
              <a href="#" className="btn btn-block btn-secondary p12" onClick={this.handleDoneOnClick}>
                Done
              </a>
            </div>
          </div>
        </div>
      )
    }
  })
}

